/**
 * 常量定义
 * 从 sheep/helper/const.js 转换
 */

// ========== 平台相关 ==========

/** 终端类型枚举 */
export enum TerminalEnum {
	UNKNOWN = 0, // 未知
	WECHAT_MINI_PROGRAM = 10, // 微信小程序
	WECHAT_WAP = 11, // 微信公众号
	H5 = 20, // H5 网页
	APP = 31, // 手机 App
}

/**
 * 获取当前终端类型
 * @returns 终端类型值
 */
export const getTerminal = () : TerminalEnum => {
	// #ifdef APP-PLUS
	return TerminalEnum.APP
	// #endif

	// #ifdef H5
	return TerminalEnum.H5
	// #endif

	// #ifdef MP-WEIXIN
	return TerminalEnum.WECHAT_MINI_PROGRAM
	// #endif

	// #ifdef MP
	return TerminalEnum.WECHAT_MINI_PROGRAM
	// #endif

	return TerminalEnum.UNKNOWN
}

// ========== 营销模块 ==========

/** 优惠类型枚举 */
export enum PromotionDiscountTypeEnum {
	PRICE = 1, // 满减
	PERCENT = 2, // 折扣
}

/** 优惠券有效期类型枚举 */
export enum CouponTemplateValidityTypeEnum {
	DATE = 1, // 固定日期可用
	TERM = 2, // 领取之后可用
}

/** 时间段状态枚举 */
export enum TimeStatusEnum {
	WAIT_START = '即将开始',
	STARTED = '进行中',
	END = '已结束',
}

/** 微信小程序订阅模板 */
export enum WxaSubscribeTemplate {
	TRADE_ORDER_DELIVERY = '订单发货通知',
	PROMOTION_COMBINATION_SUCCESS = '拼团结果通知',
	PAY_WALLET_RECHARGER_SUCCESS = '充值成功通知',
}

/** 营销活动类型枚举 */
export enum PromotionActivityTypeEnum {
	NORMAL = 0, // 普通
	SECKILL = 1, // 秒杀
	BARGAIN = 2, // 砍价
	COMBINATION = 3, // 拼团
	POINT = 4, // 积分商城
}

/** 配送方式枚举 */
export enum DeliveryTypeEnum {
	EXPRESS = 1, // 快递发货
	PICK_UP = 2, // 用户自提
}

export enum WishLimitFieldTypeEnum {
	TEXT = 0, // 0文本
	NUMBER = 1, // 1数字
	TIME = 2, // 2时间
	SELECT = 3, // 3下拉选
	IMAGE = 4, // 4图片
	BOOLEAN = 5 // 5布尔开关
}


/**
 * 获取时间段状态
 * @param startTime 开始时间
 * @param endTime 结束时间
 * @returns 状态文本
 */
export const getTimeStatus = (startTime : string | number | Date, endTime : string | number | Date) : TimeStatusEnum => {
	const now = Date.now()
	const start = new Date(startTime).getTime()
	const end = new Date(endTime).getTime()

	if (now < start) {
		return TimeStatusEnum.WAIT_START
	} else if (now > end) {
		return TimeStatusEnum.END
	} else {
		return TimeStatusEnum.STARTED
	}
}

// ========== 分享相关 ==========

/** 分享页面枚举 */
export const SharePageEnum = {
	HOME: {
		name: '首页',
		page: '/pages/index/index',
		value: '1',
	},
	GOODS: {
		name: '普通商品页',
		page: '/pages/goods/index',
		value: '2',
	},
	GROUPON: {
		name: '拼团商品页',
		page: '/pages/goods/groupon',
		value: '3',
	},
	SECKILL: {
		name: '秒杀商品页',
		page: '/pages/goods/seckill',
		value: '4',
	},
	GROUPON_DETAIL: {
		name: '拼团详情页',
		page: '/pages/activity/groupon/detail',
		value: '5',
	},
	POINT: {
		name: '积分商品页',
		page: '/pages/goods/point',
		value: '6',
	},
	WISH_DETAIL: {
		name: '愿望详情',
		page: '/pages-sub/wish-detail/wish-detail',
		value: '7',
	},
	FEED_DETAIL: {
		name: '故事墙详情',
		page: '/pages-sub/feed-detail/feed-detail',
		value: '8',
	},
	LIMIT_CHECKIN: {
		name: '自律打卡',
		page: '/pages-sub/limit-checkin/limit-checkin',
		value: '9',
	}
}